import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'sms-price-view',
    templateUrl: './sms-price-view.component.html',
    styleUrls: ['./sms-price-view.component.scss'],
    standalone: false
})
export class SmsPriceViewComponent implements OnInit {


  @Input() persianPrice:number =0;
  @Input() englishPrice:number = 0;
  @Input() currency:string = "Rls";
  @Input() title:string = "";
  @Input() description: string = "";

  constructor() { }

  ngOnInit(): void {
  }

}
